import Api from './Api'

export default {
    getBuscarEspecialistas({ lat, lng, page = 1, type, name }) {
        const params = new URLSearchParams({ page, type });
        if (name) params.append('name', name);
        if (lat != null && lng != null) {
            params.append('lat', lat);
            params.append('lng', lng);
        }
        return Api().get(`/socios?${params.toString()}`);
    }
}
